<template>
  <b-card>
    <b-card-title>
      <h3>{{ pageTitle }}</h3>
    </b-card-title>
    <validation-observer ref="campaignValidation">
      <b-form @submit.prevent>
        <b-row>
          <b-col md="6" class="mb-1">
            <validation-provider
              #default="{ errors }"
              name="desc"
              rules="required"
            >
              <div class="form-label-group">
                <b-form-textarea
                  id="desc"
                  v-model="desc"
                  placeholder="توضیحات..."
                  rows="3"
                  max-rows="3"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
                <label for="desc">توضیحات</label>
              </div>
            </validation-provider>
          </b-col>
          <!-- </b-col> -->
          <b-col md="6" class="mb-1">
            <validation-provider
              #default="{ errors }"
              name="targetUrl"
              rules="required"
            >
              <div class="form-label-group">
                <b-form-input
                  id="targetUrl"
                  placeholder="لینک هدف..."
                  v-model="targetUrl"
                />
                <small class="text-danger">{{ errors[0] }}</small>
                <label for="targetUrl">لینک هدف</label>
              </div>
            </validation-provider>
          </b-col>
          <b-col md="6" class="mb-1" align-self="center">
            <validation-provider
              #default="{ errors }"
              name="video"
              :rules="{ required: isVideoRequired }"
            >
              <div class="form-label-group">
                <!-- <b-form-input
                  id="videoUrl"
                  placeholder="لینک ویدیو..."
                  v-model="videoUrl"
                /> -->
                <b-form-file
                  id="videoFile"
                  placeholder="تیزر را انتخاب یا کشیده و اینجا رها کنید"
                  drop-placeholder="تیزر را اینجا رها کنید"
                  accept=".mp4"
                  v-model="videoFile"
                  align-v="center"
                />
                <small class="text-danger">{{ errors[0] }}</small>
                <label for="videoUrl">تیزر</label>
              </div>
            </validation-provider>
          </b-col>
          <b-col md="6" class="mb-1">
            <div class="form-label-group">
              <b-embed
                v-if="videoFile"
                type="video"
                center
                :src="videoSrc"
                class="mb-1"
                style="height: 200px"
              />
              <b-button
                v-if="showVideoUploadButton"
                block
                variant="primary"
                @click="uploadVideo(updateVideoUploadPercentage)"
                >آپلود</b-button
              >
              <b-progress
                v-else-if="videoUploadProgress !== -1"
                animated
                max="100"
                class="progress-bar-success"
              >
                <b-progress-bar
                  :value="videoUploadProgress"
                  :label="`${videoUploadProgress.toFixed(1)}%`"
                  variant="success"
                />
              </b-progress>
            </div>
          </b-col>
          <!-- <b-col md="12" class="mb-1"> -->
          <!-- <b-row class="match_height"> -->
          <b-col md="6" align-self="center" class="mb-1">
            <validation-provider
              #default="{ errors }"
              name="image"
              rules="required|image|size:1024"
            >
              <div class="form-label-group">
                <!-- <b-form-input
                  id="imageUrl"
                  placeholder="لینک تصویر..."
                  v-model="imageUrl"
                /> -->
                <b-form-file
                  id="imageFile"
                  placeholder="تصویر هدف افقی را انتخاب یا کشیده و اینجا رها کنید"
                  drop-placeholder="تصویر افقی را اینجا رها کنید"
                  accept=".jpg, .jpeg"
                  v-model="imageFile"
                  align-v="center"
                />
                <small class="text-danger">{{ errors[0] }}</small>
                <label for="imageFile"> تصویر هدف</label>
              </div>
            </validation-provider>
          </b-col>
          <b-col md="6" class="mb-1">
            <div class="form-label-group">
              <b-img
                v-if="imageFile"
                center
                :src="imageSrc"
                class="mb-1"
                style="height: 200px"
              />
              <b-button
                v-if="showImageUploadButton"
                block
                variant="primary"
                @click="uploadImage(updateImageUploadPercentage)"
                >آپلود</b-button
              >
              <b-progress
                v-else-if="imageUploadProgress !== -1"
                animated
                max="100"
                class="progress-bar-success"
              >
                <b-progress-bar
                  :value="imageUploadProgress"
                  :label="`${imageUploadProgress.toFixed(1)}%`"
                  variant="success"
                />
              </b-progress>
            </div>
          </b-col>
          <!-- </b-row> -->

          <b-col md="6" align-self="center" class="mb-1">
            <validation-provider
              #default="{ errors }"
              name="image"
              rules="required|image|size:1024"
            >
              <div class="form-label-group">
                <!-- <b-form-input
                  id="imageUrl"
                  placeholder="لینک تصویر..."
                  v-model="imageUrl"
                /> -->
                <b-form-file
                  id="portraitImageFile"
                  placeholder="تصویر عمودی را انتخاب یا کشیده و اینجا رها کنید"
                  drop-placeholder="تصویر عمودی را اینجا رها کنید"
                  accept=".jpg, .jpeg"
                  v-model="portraitImageFile"
                  align-v="center"
                />
                <small class="text-danger">{{ errors[0] }}</small>
                <label for="portraitImageFile"> عمودی تصویر هدف</label>
              </div>
            </validation-provider>
          </b-col>
          <b-col md="6" class="mb-1">
            <div class="form-label-group">
              <b-img
                v-if="portraitImageFile"
                center
                :src="portraitImageSrc"
                class="mb-1"
                style="height: 200px"
              />
              <b-button
                v-if="showPortraitImageUploadButton"
                block
                variant="primary"
                @click="
                  uploadPortraitImage(updatePortraitImageUploadPercentage)
                "
                >آپلود</b-button
              >
              <b-progress
                v-else-if="portraitImageUploadProgress !== -1"
                animated
                max="100"
                class="progress-bar-success"
              >
                <b-progress-bar
                  :value="portraitImageUploadProgress"
                  :label="`${portraitImageUploadProgress.toFixed(1)}%`"
                  variant="success"
                />
              </b-progress>
            </div>
          </b-col>

          <b-col md="6" class="mb-1">
            <validation-provider
              #default="{ errors }"
              name="viewLimit"
              rules="required|positive"
            >
              <div class="form-label-group">
                <b-form-input
                  id="viewLimit"
                  placeholder="حد اکثر تعداد نمایش..."
                  v-model="viewLimit"
                />
                <small class="text-danger">{{ errors[0] }}</small>
                <label for="viewLimit">حداکثر نمایش</label>
              </div>
            </validation-provider>
          </b-col>
          <b-col md="6" class="mb-1">
            <validation-provider
              #default="{ errors }"
              name="buttonText"
              rules="required"
            >
              <div class="form-label-group">
                <b-form-input
                  id="buttonText"
                  placeholder="متن دکمه هدف..."
                  v-model="buttonText"
                />
                <small class="text-danger">{{ errors[0] }}</small>
                <label for="buttonText">متن دکمه</label>
              </div>
            </validation-provider>
          </b-col>
          <b-col md="6" class="mb-1">
            <validation-provider
              #default="{ errors }"
              name="type"
              rules="required"
            >
              <div class="form-label-group">
                <b-form-select id="campaignType" v-model="campaignType">
                  <b-form-select-option :value="null"
                    >لطفا نوع تبلیغ را انتخاب کنید</b-form-select-option
                  >
                  <b-form-select-option :value="0"
                    >جایزه ای</b-form-select-option
                  >
                  <b-form-select-option :value="1">ویدیو</b-form-select-option>
                  <b-form-select-option :value="2">عکس</b-form-select-option>
                </b-form-select>
                <small class="text-danger">{{ errors[0] }}</small>
                <label for="campaignType">نوع تبلیغ</label>
              </div>
            </validation-provider>
          </b-col>
          <b-col md="6" class="mb-1">
            <validation-provider
              #default="{ errors }"
              name="date"
              rules="required"
            >
              <div class="form-label-group">
                <flat-pickr
                  id="datePicker"
                  class="form-control"
                  v-model="expireDate"
                  :config="config"
                ></flat-pickr>
                <small class="text-danger">{{ errors[0] }}</small>
                <label for="datePicker">تاریخ انقضا</label>
              </div>
            </validation-provider>
          </b-col>
        </b-row>
        <b-button type="submit" block @click="validateForm" variant="primary"
          >ثبت</b-button
        >
      </b-form>
    </validation-observer>
  </b-card>
</template>
<script>
// Validation Section
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'

import { required } from '@validations'
import fa from 'vee-validate/dist/locale/fa.json'

// DatePicker Section
// import mFlatpickr from 'flatpickr'
import { Persian } from 'flatpickr/dist/l10n/fa'
import flatPickr from 'vue-flatpickr-component'

import axios from '@axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

import {
  BRow,
  BCol,
  BCard,
  BCardTitle,
  BForm,
  BFormTextarea,
  BFormInput,
  BButton,
  BFormSelect,
  BFormSelectOption,
  BFormFile,
  BImg,
  BProgress,
  BProgressBar,
  BEmbed,
} from 'bootstrap-vue'

import { image, size, positive } from '../../libs/utils/validations'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardTitle,
    BForm,
    BFormTextarea,
    BFormInput,
    BButton,
    BFormSelect,
    BFormSelectOption,
    BFormFile,
    BImg,
    BProgress,
    BProgressBar,
    BEmbed,
    ValidationObserver,
    ValidationProvider,
    flatPickr,
  },
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      desc: '',
      videoUrl: '',
      imageUrl: '',
      portraitImageUrl: '',
      targetUrl: '',
      expireDate: null,
      buttonText: '',
      campaignType: null,
      imageFile: null,
      portraitImageFile: null,
      viewLimit: null,
      videoFile: null,
      imageUploadProgress: -1,
      portraitImageUploadProgress: -1,
      videoUploadProgress: -1,
      config: {
        locale: Persian,
        minDate: 'today',
      },
      required,
      positive,
      image,
      size,
    }
  },
  computed: {
    pageTitle() {
      if (this.id) {
        return 'ویرایش'
      }
      return 'تبلیغ جدید'
    },
    imageSrc() {
      if (this.imageFile && this.imageUrl === '') {
        return URL.createObjectURL(this.imageFile)
      }
      if (this.imageUrl !== '') {
        return this.imageUrl
      }
      return null
    },
    portraitImageSrc() {
      if (this.portraitImageFile && this.portraitImageUrl === '') {
        return URL.createObjectURL(this.portraitImageFile)
      }
      if (this.portraitImageUrl !== '') {
        return this.portraitImageUrl
      }
      return null
    },
    videoSrc() {
      if (this.videoFile && this.videoUrl === '') {
        return URL.createObjectURL(this.videoFile)
      }
      if (this.videoUrl !== '') {
        return this.videoUrl
      }
      return null
    },
    showImageUploadButton() {
      // console.log(`file is ${this.imageFile}`)
      // console.log(`url is ${this.imageUrl === ''}`)
      // console.log(`here is ${this.imageFile !== null && this.ImageUrl === ''}`)
      if (this.imageFile) if (this.imageUrl === '') return true

      return false
      // return this.imageFile && this.ImageUrl === ''
    },
    showPortraitImageUploadButton() {
      // console.log(`file is ${this.imageFile}`)
      // console.log(`url is ${this.imageUrl === ''}`)
      // console.log(`here is ${this.imageFile !== null && this.ImageUrl === ''}`)
      if (this.portraitImageFile) if (this.portraitImageUrl === '') return true

      return false
      // return this.imageFile && this.ImageUrl === ''
    },
    showVideoUploadButton() {
      if (this.videoFile) if (this.videoUrl === '') return true

      return false
    },
    isVideoRequired() {
      return this.campaignType !== 2
    },
  },
  created() {
    // flatPickr.setDefaults({
    //   locale: Persian,
    //   enableTime: true,
    //   dateFormat: 'd-m-Y H:i',
    //   time_24hr: true,
    //   minDate: 'today',
    // })
    localize({
      fa: {
        messages: fa.messages,
        names: {
          desc: 'توضیحات',
          video: 'ویدیو',
          image: 'تصویر',
          targetUrl: 'لینک هدف',
          type: 'نوع تبلیغ',
          buttonText: 'متن دکمه',
          date: 'تاریخ انقضا',
          viewLimit: 'تعداد نمایش',
        },
        fields: {
          viewLimit: {
            positive: 'تعداد نمایش باید یک عدد مثبت باشد',
          },
        },
      },
    })

    localize('fa')
  },
  methods: {
    validateForm() {
      this.$refs.campaignValidation.validate().then(success => {
        if (!success) return
        if (this.imageUrl === '') {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'ابتدا تصویر را آپلود کنید',
              icon: 'InfoIcon',
              variant: 'info',
            },
          })
          return
        }
        if (this.isVideoRequired && this.videoUrl === '') {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'ابتدا تیزر را آپلود کنید',
              icon: 'InfoIcon',
              variant: 'info',
            },
          })
          return
        }
        axios
          .post('/campaign/new', {
            Description: this.desc,
            VideoUrl: this.videoUrl === '' ? null : this.videoUrl,
            ImageUrl: this.imageUrl,
            PortraitImageUrl: this.portraitImageUrl,
            TargetUrl: this.targetUrl,
            CampaignType: this.campaignType,
            ButtonText: this.buttonText,
            ExpiryDate: this.expireDate,
            ViewLimit: this.viewLimit,
          })
          .then(response => {
            if (!response.data.success) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.generateAlertTitle(response.data.message),
                  icon: 'AlertCircleIcon',
                  variant: 'danger',
                },
              })
            } else {
              this.$swal({
                title: 'ذخیره شد.',
                confirmButtonText: 'باشه',
                icon: 'success',
                customClass: {
                  confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
                allowOutsideClick: false,
              }).then(() => {
                this.$refs.campaignValidation.reset()
                this.clearForm()
              })
            }
            // console.log(response)
          })
          .catch(() => {
            // console.log(error)
          })

        // console.log(success)
      })
    },
    generateAlertTitle(key) {
      switch (key) {
        default:
          return key
      }
    },
    clearForm() {
      this.desc = ''
      this.videoUrl = ''
      this.imageUrl = ''
      this.PortraitImageUrl = ''
      this.targetUrl = ''
      this.expireDate = null
      this.buttonText = ''
      this.campaignType = null
      this.imageFile = null
      this.portraitImageFile = null
      this.videoFile = null
      this.imageUploadProgress = -1
      this.portraitImageUploadProgress = -1
      this.videoUploadProgress = -1
      this.viewLimit = null
    },
    uploadImage(onProgress) {
      if (this.imageFile) {
        this.imageUploadProgress = 0
        const formData = new FormData()
        formData.append('file', this.imageFile)
        const config = {
          onUploadProgress(progressEvent) {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total,
            )

            if (onProgress) onProgress(percentCompleted)
          },
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
        axios
          .post('/campaign/new/uploadCampaignImage', formData, config)
          .then(response => {
            if (response.data.success) {
              this.imageUrl = `\\${response.data.data.imageUrl}`
            }
          })
          .catch(() => {
            // console.log(error)
          })
      }
    },
    uploadPortraitImage(onProgress) {
      if (this.portraitImageFile) {
        this.portraitImageUploadProgress = 0
        const formData = new FormData()
        formData.append('file', this.portraitImageFile)
        const config = {
          onUploadProgress(progressEvent) {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total,
            )

            if (onProgress) onProgress(percentCompleted)
          },
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
        axios
          .post('/campaign/new/uploadCampaignImage', formData, config)
          .then(response => {
            if (response.data.success) {
              this.portraitImageUrl = `\\${response.data.data.imageUrl}`
            }
          })
          .catch(() => {
            // console.log(error)
          })
      }
    },
    uploadVideo(onProgress) {
      if (this.videoFile) {
        this.videoUploadProgress = 0
        const formData = new FormData()
        formData.append('file', this.videoFile)
        const config = {
          onUploadProgress(progressEvent) {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total,
            )

            if (onProgress) onProgress(percentCompleted)
          },
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
        axios
          .post('/campaign/new/uploadCampaignVideo', formData, config)
          .then(response => {
            if (response.data.success) {
              this.videoUrl = `\\${response.data.data.videoUrl}`
            }
          })
          .catch(() => {
            // console.log(error)
          })
      }
    },
    updateImageUploadPercentage(percentCompleted) {
      this.imageUploadProgress = percentCompleted
    },
    updatePortraitImageUploadPercentage(percentCompleted) {
      this.portraitImageUploadProgress = percentCompleted
    },
    updateVideoUploadPercentage(percentCompleted) {
      this.videoUploadProgress = percentCompleted
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
